import React from "react"
import { Navigate } from "react-router-dom"
import { useSelector } from "react-redux/es/hooks/useSelector"

function PrivateRoute({ children }) {
  const { isAuthenticated } = useSelector((state) => state.auth)

  if (!isAuthenticated) {
    return <Navigate to={process.env.REACT_APP_ENDPOINT} replace />
  }
  return children
}
export default PrivateRoute
